import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { SchedCheckService } from '../services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable, merge, of } from 'rxjs';
import { map, scan } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LateShiftReason, Shift } from '../models';

@Component({
  selector: 'app-late-to-work',
  templateUrl: './late-to-work.component.html',
  styles: [
    `
      .w-20rem {
        width: 20rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LateToWorkComponent implements OnInit {
  @Input() set late(l: LateShiftReason) {
    this._late.next(l);
  }

  private _late = new BehaviorSubject<LateShiftReason | undefined>(undefined);

  formGroup!: FormGroup;
  viewModel$!: Observable<ViewModel>;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {}

  private initFormGroup() {
    this.formGroup = this.fb.group({
      reason: this.fb.control(undefined, Validators.required),
    });
  }

  private initViewModel() {
    this.viewModel$ = merge<Partial<ViewModel>>(
      of(reasons).pipe(map((reasons) => ({ reasons }))),
      this._late.pipe(
        map((late) => ({
          campaignId: late?.campaignId,
          startTime: late?.startUtc.toLocaleTimeString('en-AU', {
            timeStyle: 'short',
          }),
        }))
      )
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  logReason() {
    if (this.formGroup.valid) {
      const { reason } = this.formGroup.value;
      const late = this._late.value;
      this.activeModal.close({ ...late, reason });
    }
  }

  ngOnInit(): void {
    this.initFormGroup();
    this.initViewModel();
  }
}

interface ViewModel {
  campaignId?: number;
  reasons?: string[];
  startTime?: string;
}

const reasons = [
  'I was unwell',
  'I had an appointment',
  'I got stuck in traffic',
  'Whoops, I slept in',
  'I had an Internet/Power Outage',
  'I had caregiver responsibilities',
  'Other',
];
